import React from 'react';
import FieldObject from './field_object';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';
import DateRangePicker from '@grnhse/seedling/lib/birch/components/forms/date_picker/date_range_picker';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';

const t = withLocalePrefix('talent_search.form.sections.candidate.labels');

type Props = {
  fieldObject: FieldObject;
  onUpdate: (val: FieldObject) => void;
};

const DateRangeWrapper = styled.div`
  > div {
    display: flex;

    > div {
      max-width: 50%;
    }

    .react-datepicker-wrapper {
      width: inherit;
    }

    .react-datepicker {
      width: 310px;
    }
  }
`;

const DateOption = ({ fieldObject, onUpdate }: Props) => {
  const { watch } = useFormContext();
  const userDateFormat = watch('user_date_format');
  const start = fieldObject.min as Date | null;
  const end = fieldObject.max as Date | null;

  const onDateRangeChange = (startDate: Date | null, endDate: Date | null) => {
    fieldObject.setMin(startDate);
    fieldObject.setMax(endDate);
    onUpdate(fieldObject);
  };

  return (
    <DateRangeWrapper>
      <DateRangePicker
        label={t('date_range')}
        onChange={onDateRangeChange}
        selectedStart={start}
        selectedEnd={end}
        dateFormat={userDateFormat}
      >
        <DateRangePicker.Start label={t('date_start')} />
        <DateRangePicker.End label={t('date_end')} />
      </DateRangePicker>
    </DateRangeWrapper>
  );
};

export default DateOption;
